var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPellets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 534.1,
    y1: 298.2,
    x2: 534.1,
    y2: 854.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9a877",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#c9a877",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#c9a877",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#c9a877",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#c9a877",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#c9a877",
    stopOpacity: 0.5
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pellets") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "transparent_squares",
    "data-name": "transparent squares"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.66,
    width: 1000,
    height: 1000,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "dryfood"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sack"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M748.82,360.3a63.73,63.73,0,0,0-6.73-27.09l-17.75-35.44-36.66-73.2a33.28,33.28,0,0,1-3.55-15V189A31.07,31.07,0,0,0,653,158H322a33.55,33.55,0,0,0-33.6,33.5v17.09c0,.45,0,.91,0,1.36a33.44,33.44,0,0,1-1.21,7.65l-5.24,603.08c5.44,8.08,7,10.09,8.91,12.59a.87.87,0,0,1,.08.1c8,9.23,17.07,15.26,25.63,18.28a69.33,69.33,0,0,0,10,2.21,25.05,25.05,0,0,0,3.19.23H715.24c1.09,0,2.16-.06,3.23-.16.21,0,.41,0,.63-.07l.39,0c.39,0,.78-.1,1.17-.17s1-.17,1.45-.27,1-.22,1.52-.34.81-.22,1.2-.34l.83-.26c.47-.14.92-.3,1.37-.47s.86-.33,1.28-.51,1-.44,1.49-.68a31.3,31.3,0,0,0,2.86-1.54,30.73,30.73,0,0,0,2.69-1.8c.36-.27.72-.55,1.06-.83l.54-.45a3.46,3.46,0,0,0,.4-.35l.78-.69.87-.84a5.88,5.88,0,0,0,.43-.44c.24-.24.47-.47.68-.72a31.66,31.66,0,0,0,3-3.84c.31-.42.57-.86.84-1.31s.5-.81.72-1.23l.26-.47c.14-.26.28-.53.4-.8s.19-.36.27-.54c.16-.33.31-.67.46-1,.27-.6.5-1.19.73-1.8s.36-1,.52-1.54a.08.08,0,0,1,0,0c.16-.5.31-1,.43-1.52,0,0,0,0,0,0a.37.37,0,0,0,0-.14.31.31,0,0,0,0-.13c.09-.33.17-.66.23-1a.23.23,0,0,0,0-.11c0-.18.08-.35.11-.53.18-.88.31-1.77.41-2.68l.07-.7c0-.47.08-.93.1-1.4s.05-1.12.05-1.68V362.15C748.85,361.53,748.83,360.91,748.82,360.3Z",
    style: {
      fill: "#e0c39d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.37
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.73,217.55h-2.57a32.73,32.73,0,0,0,1.16-7.49A32.91,32.91,0,0,0,289.73,217.55Z",
    style: {
      fill: "#a3865a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.24
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.73,217.55h-2.57a32.73,32.73,0,0,0,1.16-7.49A32.91,32.91,0,0,0,289.73,217.55Z",
    style: {
      fill: "#a3865a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M748.85,362.15V820.56c0,.56,0,1.12-.05,1.68s0,.93-.1,1.4l-.07.7c-.1.91-.23,1.8-.41,2.68,0,.18-.07.35-.11.53a.23.23,0,0,1,0,.11c-.06.34-.14.67-.23,1a.31.31,0,0,1,0,.13.37.37,0,0,1,0,.14s0,0,0,0c-.12.52-.27,1-.43,1.52a.08.08,0,0,0,0,0c-.16.52-.33,1-.52,1.54s-.46,1.2-.73,1.8c-.15.34-.3.68-.46,1q-.12.27-.27.54c-.12.27-.26.54-.4.8l-.26.47q-.33.63-.72,1.23c-.27.45-.53.89-.84,1.31a31.66,31.66,0,0,1-3,3.84c-.21.25-.44.48-.68.72a5.88,5.88,0,0,1-.43.44l-.87.84-.78.69a3.46,3.46,0,0,1-.4.35l-.54.45c-.34.28-.7.56-1.06.83a30.73,30.73,0,0,1-2.69,1.8,31.3,31.3,0,0,1-2.86,1.54c-.48.24-1,.46-1.49.68s-.85.34-1.28.51-.9.33-1.37.47l-.83.26c-.39.12-.79.24-1.2.34s-1,.24-1.52.34-1,.19-1.45.27-.78.13-1.17.17l-.39,0c-.22,0-.42.05-.63.07-1.07.1-2.14.16-3.23.16H319.34A33.6,33.6,0,0,0,353,820.44V360.28a64.19,64.19,0,0,0-6.76-28.65l-16.7-33.43H724.34l17.75,35.42a63.63,63.63,0,0,1,6.73,26.68C748.83,360.91,748.85,361.53,748.85,362.15Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.53
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.12,217.71c0-.06,0-.1,0-.16h.05A.94.94,0,0,1,287.12,217.71Z",
    style: {
      fill: "#a3865a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M340.87,850.87c-3.85,2.38-8.81,3.38-14.35,2.94a38.82,38.82,0,0,1-10-2.21c-8.56-3-17.64-9.05-25.63-18.28a.87.87,0,0,0-.08-.1,83,83,0,0,1-8.91-12.59l5.25-602.92s0-.1,0-.16h2.57a32,32,0,0,0,2,5.11l37.72,75.54,16.7,33.43A64.19,64.19,0,0,1,353,360.28V820.44C353,823.82,352.75,843.53,340.87,850.87Z",
    style: {
      fill: "#c69e79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.09,217.55h-398a33.44,33.44,0,0,0,1.21-7.65c0-.45,0-.91,0-1.36V191.45A33.55,33.55,0,0,1,322,158H653a31.07,31.07,0,0,1,31.11,31v20.63A33.06,33.06,0,0,0,685.09,217.55Z",
    style: {
      fill: "#ceac8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.1,215.19l1.63,603.1-36.41-26.17c-3.77-6.27-6-14.94-6.06-24l-4.7-412.17a54.76,54.76,0,0,1,2.35-16.75S283.66,215,287.1,215.19Z",
    style: {
      fill: "#c69e79"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.34,
    y: 413.55,
    width: 324.58,
    height: 324.58,
    rx: 23.3,
    style: {
      fill: "#fff4eb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M666.79,559a149.15,149.15,0,0,0-5.64-39.66,157.79,157.79,0,0,0-12.58-31.25h6.18a8.27,8.27,0,0,0,8.28-8.28V461.49a8.34,8.34,0,0,0-8.34-8.35H612a8.29,8.29,0,0,0-8.28,8.29v11.93a49.9,49.9,0,0,0,2.2,14.73,48.81,48.81,0,0,0,3.59,8.64.3.3,0,0,1,0,.08c.68,1.1,1.38,2.27,2.1,3.52a118.4,118.4,0,0,1,15.91,58.48c0,12.55.06,48-27,73.07-5.16,4.77-22.29,20.61-45.11,20.63s-39.95-15.86-45.11-20.63c-27.08-25-27-60.52-27-73.07a118.39,118.39,0,0,1,15.92-58.48c.71-1.25,1.41-2.42,2.09-3.52,0,0,0-.05,0-.08a48.81,48.81,0,0,0,3.59-8.64,49.9,49.9,0,0,0,2.2-14.73V461.43a8.28,8.28,0,0,0-8.28-8.29H456.17a8.35,8.35,0,0,0-8.35,8.35v18.32a8.28,8.28,0,0,0,8.28,8.28h6.19a157.11,157.11,0,0,0-12.59,31.25A149.15,149.15,0,0,0,444.06,559c-.07,12.82-.39,64.35,39.36,101.27,8.29,7.7,33.44,30.35,72,31.22,38.57-.87,63.72-23.52,72-31.22C667.18,623.35,666.87,571.82,666.79,559Z",
    style: {
      fill: "#b748ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.9,
    y: 583.64,
    width: 13.42,
    height: 27.86,
    rx: 6.71,
    transform: "translate(1141.6 1319.41) rotate(-167.58)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 606.15,
    y: 634.62,
    width: 13.42,
    height: 27.86,
    rx: 6.71,
    transform: "translate(587.61 1540.5) rotate(-135)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.65,665.89H549.21a6.71,6.71,0,0,0,0,13.42h14.44a6.71,6.71,0,1,0,0-13.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.21,
    y: 521.61,
    width: 13.42,
    height: 27.86,
    rx: 6.71,
    transform: "translate(1392.38 915.04) rotate(167.21)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.54,
    y: 583.64,
    width: 13.42,
    height: 27.86,
    rx: 6.71,
    transform: "translate(-117.55 115.17) rotate(-12.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.29,
    y: 634.62,
    width: 13.42,
    height: 27.86,
    rx: 6.71,
    transform: "translate(-312.15 543.51) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.23,
    y: 521.61,
    width: 13.42,
    height: 27.86,
    rx: 6.71,
    transform: "translate(130.15 -90.29) rotate(12.79)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPellets);
export default __webpack_public_path__ + "static/media/pellets.b505ee29b937aaf5153858d988d6776b.svg";
export { ForwardRef as ReactComponent };